export type OrderBys = { [key: string]: OrderBy }

export type OrderBy = 'asc' | 'desc'

export default class QueryModifiers {
	constructor(public orderBys: OrderBys) {}
}
